const StatusLoginEnum = {
    LOGADO: "LOGADO",
    NAO_LOGADO: "NAO_LOGADO"
};

Object.freeze(StatusLoginEnum);

export {StatusLoginEnum};
